import { render, staticRenderFns } from "./SaveTheDocument.vue?vue&type=template&id=49736d20&"
import script from "./SaveTheDocument.vue?vue&type=script&lang=js&"
export * from "./SaveTheDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports